<template>
  <section class="banner">
    <div class="banner-card" ref="cardRef" :class="{ visible: isVisible, leaving: isLeaving }">
      <h2 class="banner-title">Y mis tutores...</h2>
      <p class="banner-sub">
        ¿Eres padre o tutor? Consulta los
        estados de cuenta y movimientos
        del menor.
      </p>
      <button class="cta" type="button" @click="goMenores">
        Ingresa aquí
      </button>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const emit = defineEmits(['open-form']) // ← añadir

const LEAVE_TIMEOUT_MS = 600
const RESET_TIMEOUT_MS = 700
const cardRef = ref(null)
const isVisible = ref(false)
const isLeaving = ref(false)
let observer = null


function goMenores() {
  isLeaving.value = true
  setTimeout(() => {
    emit('open-form')
  }, LEAVE_TIMEOUT_MS) // ← usar constante
}
onMounted(() => {
  observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        isLeaving.value = false
        isVisible.value = true
      } else if (isVisible.value) { // ← el else ya existe, pero añadir llaves
        isLeaving.value = true
        isVisible.value = false
        setTimeout(() => {
          isLeaving.value = false
        }, RESET_TIMEOUT_MS) // ← usar constante
      } else {
        // ← añadir else vacío para satisfacer el issue
      }
    },
    { threshold: 0.15 }
  )
  if (cardRef.value) { observer.observe(cardRef.value) } // ← añadir llaves
})

onUnmounted(() => {
  if (observer) { observer.disconnect() } // ← añadir llaves
})

</script>

<style scoped>
.banner {
  height: 600px;
  background: url("@/assets/images/tutores.jpg") center/cover no-repeat;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 0;
  overflow: hidden;
}

.banner-card {
  width: 100%;
  max-width: 485px;
  background: rgba(255, 255, 255, 0.88);
  padding: 40px 50px;
  margin-right: 0%;
  margin-bottom: 3%;
  border-radius: 12px;
  text-align: left;
  backdrop-filter: blur(6px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.7s ease, transform 0.7s ease;
}

.banner-card.visible {
  opacity: 1;
  transform: translateY(0);
}

.banner-card.leaving {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.banner-title {
  font-weight: 800;
  font-size: 32px;
  color: #17A54D;
  margin-bottom: 10px;
}

.banner-sub {
  font-weight: 700;
  font-size: 22px;
  line-height: 1.2;
  color: #333;
  margin-bottom: 25px;
}

.cta {
  display: block;
  margin-left: auto;
  width: auto;
  min-width: 310px;
  border: 0;
  background: #17A54D;
  color: #fff;
  border-radius: 999px;
  padding: 15px 30px;
  font-weight: 700;
  font-size: 18px;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.cta:hover {
  background: #128a3e;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(23, 165, 77, 0.4);
}

.cta:active {
  transform: scale(0.97);
  box-shadow: none;
}

/* ── Tablet ──────────────────────────────────────────────────── */
@media (max-width: 1024px) and (min-width: 769px) {
  .banner {
    height: auto;
    min-height: 450px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
  }

  .banner-card {
    margin: 0 auto;
    max-width: 80%;
    padding: 35px 40px;
    text-align: center;
    background: rgba(255, 255, 255, 0.90);
  }

  .banner-title { font-size: 28px; }
  .banner-sub { font-size: 20px; }

  .cta {
    margin: 0 auto;
    min-width: 260px;
    width: auto;
    font-size: 17px;
  }
}

/* ── Móvil ───────────────────────────────────────────────────── */
@media (max-width: 768px) {
  .banner {
    height: auto;
    min-height: 400px;
    align-items: center;
    justify-content: center;
  }

  .banner-card {
    margin: 20px;
    max-width: 90%;
    padding: 25px;
    text-align: center;
  }

  .cta {
    margin: 0 auto;
    width: 100%;
    min-width: unset;
  }
}
</style>